<div style="display: table-row;">
  <div
      [style]="{ 'padding-top': isAppointment ? '0px' :'0px', 'padding-bottom': isAppointment ? '0' :'0px'}"
      style="display: table-cell; width: 564px; vertical-align: top;
  padding-left: 24px;
  padding-right: 8px;">
    <div class="left"
         *ngIf="type === 'tts' || (type !== 'tts' && ttsMessage !== undefined)"
         [ngClass]="{ 'bubble-audiofile': (type !== 'tts' && ttsMessage !== undefined),  'bubble-tts': type === 'tts'}"
         tooltip="(Name: {{soundName}})">
      <table>
        <tr *ngIf="type === 'tts'">
          <td style="height: 44px; width: 12px; font-size: 36px; vertical-align: top;">“</td>
          <td>
            <div style="white-space: pre-wrap; font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                 font-size: 13px;
                 line-height: 24px;
                 max-width: 90%"
                 contenteditable=""
                 strip-br="true"
                 strip-newLine="true"
                 strip-html="true"
                 strip-nbsp="true"
                 [attr.contenteditable]="!isOnlyPreview"
                 [ng-model]="model"
                 id = "{{model}}"
                 [innerHtml]="(ttsMessage || '' ) | safe: 'html'"
                 style="width: 100%; overflow: hidden; overflow-x: auto; outline: none; border: none;
                 box-shadow: none; min-width: 300px; max-width: 500px;"
                 (click)="setSelectedNode($event)"
            >
            </div>
          </td>
          <td style="font-size: 36px; vertical-align: bottom">”</td>
        </tr>

        <tr *ngIf="type !== 'tts' && ttsMessage !== undefined">
          <td [style]="{ 'height': isAppointment ? '28px' :'28px'}"
              style="width: 12px; vertical-align: top;"></td>
          <td [style]="{ 'font-size': isAppointment ? '11px' :'11px', 'line-height': isAppointment ? '18px' : '18px' }"
              style="font-family: Helvetica Neue,Helvetica,Arial,sans-serif;">
            <div style="white-space: pre-wrap; font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                font-size: 13px;
                line-height: 24px;
                max-width: 90%"
                 contenteditable="false"
                 strip-br="true"
                 strip-newLine="true"
                 strip-html="true"
                 strip-nbsp="true"
                 [attr.contenteditable]="!isOnlyPreview"
                 [ng-model]="model"
                 id = "{{model}}"
                 [innerHtml]="(ttsMessage || '' ) | safe: 'html'"
                 style="width: 100%; overflow: hidden; overflow-x: auto; outline: none; border: none;
               box-shadow: none; min-width: 300px; max-width: 500px;"
                 (click)="setSelectedNode($event)"
                 *ngIf="ttsMessage.indexOf('template-context') !== -1"
            >
            </div>
            <div *ngIf="ttsMessage.indexOf('template-context') === -1">
              {{ttsMessage}}
            </div>
          </td>
          <td style="font-size: 24px; vertical-align: bottom"></td>
        </tr>
      </table>

    </div>
  </div>
    <div style="display: table-cell; vertical-align: middle; width: 110px" *ngIf="type === 'tts' || (type !== 'tts' && ttsMessage !== undefined)">

      <!--div style="display: table-row; border-style: solid" *ngIf="playerStatus$ | async as playerStatus">
        <div style="display: table-cell; vertical-align: middle;">
          <button class="btn btn-default"
                  style="padding: 0; border-style: none; font-size: 24px"
                  *ngIf="playerStatus !== 'playing' &&  !isLoading"
                  (click)="play();"
                  ><i class="glyphicon glyphicon-play"></i>
          </button>
          <button class="btn btn-default" style="padding: 0; border-style: none; font-size: 24px;"
                  (click)="stop();" *ngIf="playerStatus === 'playing' && !isLoading"><i class="glyphicon glyphicon-stop"></i></button>
          <button class="btn btn-default"
                  style="padding: 0; border-style: none; font-size: 24px"
                  *ngIf="isLoading">
           <img  src="/img/loading.gif" />
          </button>
        </div>
        <div style="display: table-cell; vertical-align: middle; padding-left: 2px;" *ngIf="percentElapsed$ | async as headPOS">
          <div class="player-timeline" *ngIf="playerStatus === 'playing' && userAgent.indexOf('safari') === -1">
            <div id="playhead"
                 [style]="{ 'margin-left': headPOS}" class="player-playhead"></div>
          </div>
        </div>
      </div-->
  </div>
</div>
